import { render, staticRenderFns } from "./TestSettings.vue?vue&type=template&id=5127bdb0&"
import script from "./TestSettings.vue?vue&type=script&lang=js&"
export * from "./TestSettings.vue?vue&type=script&lang=js&"
import style0 from "./TestSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports